import React from "react";
import { useNavigate } from "react-router-dom";
import getCheckIfBookPurchased from "../api/get/getCheckIfBookPurchased";

const BookItem = ({ id, image, title, price, isPaid, onPlay, onBookAccessDenied }) => {
    const navigate = useNavigate();

    const isIOS = () => {
        if (typeof window === "undefined") return false;
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    };

    const handlePlay = async () => {
        const hasAccess = await getCheckIfBookPurchased(id);

        if (!isPaid || hasAccess) {
            if (isIOS()) {
                navigate(`/read/${id}`);
            } else {
                onPlay(id, isPaid);
            }
        } else {
            onBookAccessDenied(id);
        }
    };

    return (
        <div
            className="w-full rounded-2xl"
            onClick={(e) => {
                e.stopPropagation();
                handlePlay();
            }}
        >
            <div className="relative w-full h-full overflow-hidden rounded-2xl">
                {price && price > 0 && (
                    <div className="absolute top-3 right-3 bg-yellow-400/90 text-white text-[11px] px-2 py-1 rounded-full shadow backdrop-blur-sm font-semibold uppercase tracking-wide">
                        Ақылы
                    </div>
                )}

                <img
                    src={image}
                    alt={title}
                    className="h-full w-full object-cover rounded-2xl transition-transform duration-300 hover:scale-105"
                />
            </div>
        </div>
    );
};

export default BookItem;